// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-entity {
  max-height: 250px;
  height: 250px;
  margin-bottom: 10px; }

.generation-entity-list {
  height: 190px;
  overflow: auto; }
`, "",{"version":3,"sources":["webpack://./src/components/no/motorgruppen/generation/ModelList.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,cAAc,EAAA","sourcesContent":[".model-entity {\n  max-height: 250px;\n  height: 250px;\n  margin-bottom: 10px;\n}\n\n.generation-entity-list {\n  height: 190px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
